import RestService from '../services/rest';

async function getContracts(clientId) {
  return RestService.getAuthenticated(`panel/contracts?clientId=${clientId}`);
}

export default {
  getContracts,
};
